export default __webpack_public_path__ + "static/media/carson-project-2.2d0abe6b.jpg";